export class Page {
    limit: number;
    count: number;
    offset: number;
}
